import React, { useState, useEffect } from 'react'
import { FaPlusCircle, FaRegTimesCircle } from 'react-icons/fa'
import { IconButton } from '@material-ui/core'
import Alert from '@material-ui/lab/Alert'
import { useQuery } from '@apollo/client'
import { Switch, Route } from 'react-router-dom'

import Manufacturers from './Displays/Manufacturers'
import Models from './Displays/Models'
import MakeVariant from './Displays/MakeVariant'

import BaseBin from '../BaseBin'
import VehicleCreateForm from './Forms/VehicleCreateForm'
import { Q_MANUFACTURER } from 'graphql/query'
import styles from './vehicle.module.scss'
import Loading from 'components/Global/Loading'
import Sdm from './Displays/Sdm'
import NoContents from 'components/Global/NoContents'

const VehicleBin = () => {
  const [messages, setMessages] = useState([])
  const [create, setCreate] = useState(false)
  const [loading, setLoading] = useState(true)
  const [manufacturers, setManufacturers] = useState([])
  const [sltMft, setSltMft] = useState()
  const [sltMd, setSltMd] = useState()
  const [noContents, setNoContents] = React.useState(false)

  const { refetch } = useQuery(Q_MANUFACTURER)
  const concatMessages = msg => {
    setMessages([...messages, msg])
  }

  const getManufacturer = () => {
    refetch() &&
      refetch()
        .then(res => {
          setManufacturers(res.data.rManufacturer)
          setLoading(false)
        })
        .catch(err => {
          console.error(err)
          setNoContents(true)
        })
  }
  useEffect(() => {
    getManufacturer()
  }, [refetch])

  return noContents ? (
    <NoContents />
  ) : (
    <div>
      <BaseBin
        title="Vehicle"
        actions={[
          <IconButton
            className={styles.btn}
            color="primary"
            onClick={() => setCreate(i => !i)}
          >
            {!create ? <FaPlusCircle /> : <FaRegTimesCircle />}
          </IconButton>,
        ]}
      >
        {!create ? (
          <div className={styles.wrapper}>
            <div className={styles.messageWrapper}>
              {messages.map(message => (
                <Alert
                  variant="filled"
                  severity={message.type}
                  className={styles.alert}
                >
                  {message.message}
                </Alert>
              ))}
            </div>
            {!loading ? (
              <Switch>
                <Route
                  exact
                  path="/dashboard/vehicle/:manufacturer/:model/:vvrId"
                  children={<Sdm />}
                />
                <Route
                  exact
                  path="/dashboard/vehicle/:manufacturer/:model"
                  children={<MakeVariant mdId={sltMd} />}
                />
                <Route
                  exact
                  path="/dashboard/vehicle/:manufacturer"
                  children={<Models mftId={sltMft} setSelected={setSltMd} />}
                />
                <Route
                  exact
                  path="/dashboard/vehicle"
                  children={
                    <Manufacturers
                      setMessages={concatMessages}
                      data={manufacturers}
                      setSelected={setSltMft}
                    />
                  }
                />
              </Switch>
            ) : (
              <Loading />
            )}
          </div>
        ) : (
          <VehicleCreateForm
            setCreate={setCreate}
            update={getManufacturer}
            loading={setLoading}
          />
        )}
      </BaseBin>
    </div>
  )
}

export default VehicleBin
